import {useServiceBase} from "../Components/ReactTable/useServiceBase";
import EditableReactTableV2 from "../Components/ReactTable/EditableReactTableV2";
import {INDEX_FIELD} from "../Components/ReactTable/common_custom_columns";
import {
    EditFormTextInputField
} from "../Components/ReactTable/EditRecordForm";
import React, {useState} from "react";
import PropTypes from "prop-types";
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import ConfirmationModal from "../Components/ConfirmationModal";
import {makeApiCallPost} from "../../Api/makeApiCall";
import {toastError, toastSuccess} from "../../utils/toast";
import {toast} from "react-toastify";

export const CreatePasswordSecretButton = ({secretName}) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const closeModal = () => {
        setPassword("");
        setModalIsOpen(false);
    };

    const submitSecret = () => {
        setLoading(true);
        const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/createSecret?secretName=${encodeURIComponent(secretName)}`;
        return makeApiCallPost(endpointUrl, {secretValue: password})
            .then((response) => {
                if (response?.apiError) {
                    toastError(toast, `Failed to create secret "${secretName}"`);
                } else {
                    toastSuccess(toast, `Created secret "${secretName}"`);
                    closeModal();
                }
            })
            .finally(() => setLoading(false));
    };

    return (<>
        <button className={"button hollow secondary"}
                data-testid={"create-password-secret-button"}
                onClick={() => setModalIsOpen(true)}
        >
            Create Password Secret
        </button>
        {modalIsOpen && <ConfirmationModal headerText={`Create Password Secret [${secretName}]`}
                                           confirmButtonText={"Submit"}
                                           confirmationCallback={submitSecret}
                                           cancellationCallback={closeModal}
                                           submitButtonDisabled={!password}
                                           loading={loading}
        >
            <div className={"confirmation-modal-body"}>
                <label htmlFor={"create-password-secret-input"}>Password</label>
                <input id={"create-password-secret-input"}
                       type={"password"}
                       value={password}
                       onChange={(event) => setPassword(event.target.value)}
                />
            </div>
        </ConfirmationModal>}
    </>);
};

CreatePasswordSecretButton.propTypes = {
    secretName: PropTypes.string
};

const ToastClients = () => {

    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/toastClients`
    const {loading, data, onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({endpointUrl});
    const customColumns = [
        {
            header: "",
            id: "toastClients",
            columns: [
                {header: "FTP Name", accessorKey: "ftp_name"},
                {header: "SFTP Username", accessorKey: "user_name"},
                {header: "Password Secret Name", accessorKey: "password_secret_name"},
                {
                    header: "Create Password Secret",
                    id: "create_password_secret",
                    enableColumnFilter: false,
                    enableSorting: false,
                    cell: ({row}) => <CreatePasswordSecretButton secretName={row.original.password_secret_name}/>
                }
            ]
        }]

    return (<Page name={"Toast Clients"} breadCrumbs={<Breadcrumbs items={[{label: "Configuration"}, {label: "Toast Clients"}]}/>}>
        <LoadingWrapper loading={loading}>
            <EditableReactTableV2
                filterable
                data={data.data}
                columns={customColumns}
                editTable={[
                    INDEX_FIELD,
                    {id: 'ftp_name', Component: args => <EditFormTextInputField {...args} isRequired label={"FTP Name"}/>},
                    {id: 'user_name', Component: args => <EditFormTextInputField {...args} isRequired label={"SFTP Username"}/>},
                    {id: 'password_secret_name', Component: args => <EditFormTextInputField {...args} label={"Password Secret Name"}/>},
                ]}
                onRowEditConfirmed={onRowEditConfirmed}
                onRowDeleteConfirmed={onRowDeleteConfirmed}
            />
        </LoadingWrapper>
    </Page>);
}
export default ToastClients
